var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1374_415)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4446 9.34824C19.129 8.4692 17.5822 8 16 8V0C19.1645 0 22.2579 0.938384 24.8891 2.69649C27.5203 4.45458 29.571 6.95345 30.7821 9.87704C31.993 12.8006 32.3099 16.0178 31.6926 19.1214C31.0752 22.2251 29.5514 25.0761 27.3137 27.3137C25.0761 29.5514 22.2251 31.0752 19.1214 31.6926C16.0178 32.3099 12.8006 31.993 9.87704 30.7821C6.95345 29.571 4.45458 27.5203 2.69649 24.8891C0.938384 22.2579 0 19.1645 0 16H8C8 17.5822 8.4692 19.129 9.34824 20.4446C10.2273 21.7602 11.4767 22.7855 12.9386 23.391C14.4003 23.9966 16.0089 24.155 17.5607 23.8462C19.1126 23.5376 20.538 22.7757 21.6569 21.6569C22.7757 20.538 23.5376 19.1126 23.8462 17.5607C24.155 16.0089 23.9966 14.4003 23.391 12.9386C22.7855 11.4767 21.7602 10.2273 20.4446 9.34824Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.465e-06C8 1.05058 7.79308 2.09087 7.39104 3.06147C6.989 4.03207 6.39972 4.91399 5.65685 5.65686C4.91399 6.39973 4.03208 6.989 3.06147 7.39104C2.09086 7.79308 1.05057 8 3.49688e-07 8L0 16C2.10115 16 4.18172 15.5862 6.12294 14.7821C8.06416 13.978 9.828 12.7994 11.3137 11.3137C12.7994 9.828 13.978 8.06416 14.7821 6.12294C15.5862 4.18172 16 2.10115 16 0L8 3.465e-06Z",
    fill: "#4F46E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1374_415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorLogo);
export default __webpack_public_path__ + "static/media/vendorLogo.7009e77cad7a5199ca358b0d83951bcd.svg";
export { ForwardRef as ReactComponent };